import { render, staticRenderFns } from "./add-cv.vue?vue&type=template&id=ec978a88&scoped=true&"
import script from "./add-cv.vue?vue&type=script&lang=ts&"
export * from "./add-cv.vue?vue&type=script&lang=ts&"
import style0 from "./add-cv.vue?vue&type=style&index=0&id=ec978a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec978a88",
  null
  
)

export default component.exports